import { owaspNhiToDisplayName } from 'src/app/common/violationRulesUtils';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const OwaspNhiSelectOptionAll: ISelectOption = {
  id: `${FilterTypesEnum.OwaspNhi.toString()}-all`,
  value: 'all',
  displayName: 'All',
  filterType: FilterTypesEnum.OwaspNhi,
  categoryName: FilterTypesEnum.OwaspNhi.toString(),
};

export const OwaspNhiSelectOptions: ISelectOption[] = Object.keys(owaspNhiToDisplayName).map(
  (attackKey) =>
    ({
      id: `${FilterTypesEnum.OwaspNhi.toString()}-${attackKey}`,
      value: attackKey,
      displayName: owaspNhiToDisplayName[attackKey],
      filterType: FilterTypesEnum.OwaspNhi,
      categoryName: FilterTypesEnum.OwaspNhi.toString(),
    }) as ISelectOption
);
